import * as React from "react";
import { IParagraphHistoryProps } from "./ParagraphHistoryProps";
import { Container } from "./ParagraphHistoryHelpers";
import { graphql } from "gatsby";
import History from "../../common/History/History";

const ParagraphHistory: React.FC<IParagraphHistoryProps> = (props) => {
  return (
    <Container>
      <History {...props.node} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphHistory on paragraph__history {
    id
    parent_type
    field_title
    field_description
    field_subtitle
    relationships {
      field_history {
        ... on paragraph__history_item {
          id
          field_description
          field_title
        }
      }
      media: field_media {
        relationships {
          image: field_media_image {
            publicUrl
            gatsbyImage(
              width: 1062
              height: 300
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;
export default ParagraphHistory;
